import { __assign, __rest } from "tslib";
import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { default as MuiExpansionPanel } from '@material-ui/core/ExpansionPanel';
export var useStyles = makeStyles(function (theme) { return ({
    root: function (props) {
        var border = props.border;
        var result = {
            // Hide the border set by <Paper elevation={0}> below
            '&::before': {
                display: 'none',
            },
        };
        switch (border) {
            case 'thick':
                result.borderBottom = "2px solid ".concat(theme.palette.type === 'light' ? theme.palette.background.b9 : theme.palette.background.b2);
                break;
            case 'thin':
                result.borderBottom = "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.background.b5 : theme.palette.background.b6);
                break;
        }
        return result;
    },
}); });
export var ExpansionPanel = function (props) {
    var classes = useStyles(props);
    var children = props.children, otherProps = __rest(props, ["children"]);
    return (React.createElement(MuiExpansionPanel, __assign({ elevation: 0, classes: classes }, otherProps), children));
};
export default ExpansionPanel;
//# sourceMappingURL=ExpansionPanel.js.map